import { useCallback } from 'react';

function ApplicationInfo() {
  const openOneTrustSettings = useCallback(() => {
    if (window.OneTrust) {
      window.OneTrust.ToggleInfoDisplay();
    }
  }, []);

  return (
    <>
      <div className="block w-full py-2 text-center">
        <div className="block mt-4 lg:inline-block lg:mt-0 font-medium text-charcoal-400 text-xs hover:text-charcoal-200">
          <a
            data-durable-id="trust-center-link"
            data-intercom-target="trust-center-link"
            href="https://gloo.us/legal"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Trust Center
          </a>
          <span className="mx-2">|</span>
          <a
            data-durable-id="privacy-statement-link"
            data-intercom-target="privacy-statement-link"
            href="https://gloo.us/legal/privacy-statement"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            Privacy Statement
          </a>
          <span className="mx-2">|</span>
          <>
            {/* <!-- OneTrust Cookies Settings button start --> */}
            <button
              data-durable-id="cookie-settings-link"
              data-intercom-target="cookie-settings-link"
              id="cookie-settings-link"
              onClick={openOneTrustSettings}
              className="ot-sdk-show-settings hover:underline"
            >
              Cookie Settings
            </button>
            {/* <!-- OneTrust Cookies Settings button end --> */}
          </>
        </div>
      </div>
    </>
  );
}

export default ApplicationInfo;
